import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Container from "react-bootstrap/Container";
import { Spinner, Stack } from "react-bootstrap";
import ProvidersDetails from "../details/ProvidersDetails";
import Prompt from "../../ui/prompts/Prompt";
import {
  Title,
  SpinnerContainer,
  ContentHeader,
  ViewsContainer,
  ViewsTitleContainer,
} from "../../ui/BaseComponents";

export default function ViewProviders({ data, isLoading }) {
  const [savedId, setSavedId] = useState();

  const [providers, setProviders] = useState<any[]>(
    data.filter((provider) => provider.approved)
  );

  const updateData = (updatedData) => {
    console.log(updatedData);
    let newProviders = providers.reduce(
      (newPendingProviders: any[], pendingProvider: any) => {
        if (pendingProvider.id !== updatedData.id) {
          newPendingProviders.push(pendingProvider);
        }
        return newPendingProviders;
      },
      []
    );
    console.log(newProviders);
    setProviders(newProviders);
  };

  useEffect(() => {
    setProviders(data);
  }, [data]);

  return (
    <Container fluid>
      <Title>{"Provider Details"}</Title>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
        </SpinnerContainer>
      ) : (
        <Stack>
          <ContentHeader>{"Service Providers"}</ContentHeader>
          <Row className='justify-content-md-center'>
            <Tab.Container
              id='list-group-tabs-example'
              defaultActiveKey={savedId}
            >
              <Col xs lg='5'>
                <ViewsContainer style={{ marginLeft: "5%" }}>
                  <ViewsTitleContainer>
                    {"Service Providers"}
                  </ViewsTitleContainer>
                  <ListGroup>
                    {providers.map((item: any, i) => (
                      <ListGroup.Item
                        style={
                          i % 2 === 0
                            ? {
                                height: "4em",
                                color: "#292929",
                                border: "none",
                                backgroundColor: "#D8ECFD",
                              }
                            : {
                                height: "4em",
                                color: "#292929",
                                border: "none",
                                backgroundColor: "#ECF3FE",
                              }
                        }
                        key={i}
                        action
                        variant='dark'
                        eventKey={i}
                        onClick={() => setSavedId(i)}
                      >
                        {item.first_name} {item.last_name}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </ViewsContainer>
              </Col>

              <Col xs lg='7'>
                <ViewsContainer style={{ marginRight: "5%" }}>
                  <ViewsTitleContainer>{"Details"}</ViewsTitleContainer>
                  <Tab.Content style={{ padding: ".4em" }}>
                    {savedId === undefined ? (
                      <Prompt message='Select a provider to view details.' />
                    ) : (
                      <Tab.Pane eventKey={savedId}>
                        {typeof savedId === "number" ? (
                          <ProvidersDetails
                            updateListData={updateData}
                            data={data[savedId]}
                          />
                        ) : null}
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                </ViewsContainer>
              </Col>
            </Tab.Container>
          </Row>
        </Stack>
      )}
    </Container>
  );
}
